import React from 'react';
import './StatusBadge.scss';

export type StatusType = 'pending' | 'refused' | 'accepted';

export type StatusBadgeProps = {
    status: StatusType;
};

const labels: Record<StatusType, string> = {
    pending: 'En attente',
    refused: 'Refusée',
    accepted: 'Acceptée'
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    return <span className={`status-badge status-badge--${status}`}>{labels[status]}</span>;
};
